import axios from 'axios';
import HttpException from './HttpException';
import type { AppMessage } from '@/models/appMessage';
import moment from 'moment';

class AppMessageWebservice {
    public async load(): Promise<AppMessage[]> {
        try {
            const response = await axios.get<AppMessage[]>('/app-messages');

            return response.data.map((message) => {
                return {
                    id: message.id,
                    message: message.message,
                    background_color: message.background_color,
                    font_color: message.font_color,
                    font_size: message.font_size,
                    closable: message.closable,
                    active_at: moment(message.active_at),
                    expire_at: moment(message.expire_at),
                };
            });
        } catch (error) {
            throw new HttpException(error.response.status, 'There was an error fetching the App Messages');
        }
    }
}

export const appMessageWebservice = new AppMessageWebservice();
